const CompanySection = () => {
  const services = [
    {
      title: '在留資格認定証明書交付申請',
      description: '海外から外国人材を呼び寄せる際の申請手続きを代行いたします。',
      icon: 'ri-file-text-line'
    },
    {
      title: '在留資格変更許可申請',
      description: '技能実習や留学などから特定技能への変更申請をサポートします。',
      icon: 'ri-exchange-line'
    },
    {
      title: '在留期間更新許可申請',
      description: '特定技能ビザの更新手続きを迅速に対応いたします。',
      icon: 'ri-refresh-line'
    },
    {
      title: '支援計画書の作成',
      description: '1号特定技能外国人支援計画の作成をサポートします。',
      icon: 'ri-file-list-3-line'
    }
  ];

  const concerns = [
    '特定技能ビザの申請方法が分からない',
    '書類作成に時間がかかりすぎる',
    '不許可になるリスクを減らしたい',
    '急ぎで申請を進めたい',
  ];

  return (
    <section id="company" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* セクションヘッダー */}
        <div className="flex items-start gap-4 md:gap-6 mb-10 md:mb-16">
          <div className="flex-shrink-0 pt-1">
            <div className="w-px h-12 md:h-16 bg-[#1a3a5c]"></div>
          </div>
          <div>
            <p className="text-[#1a3a5c] text-xs tracking-[0.3em] font-medium uppercase mb-2">For Accepting Companies</p>
            <h2
              className="text-3xl md:text-4xl font-bold text-slate-800 mb-3"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              受け入れ企業の方へ
            </h2>
            <p className="text-slate-500 text-sm">特定技能外国人の受け入れをトータルサポート</p>
          </div>
        </div>

        {/* メインコンテンツ：写真＋サービス */}
        <div className="grid lg:grid-cols-5 gap-8 md:gap-12 mb-10 md:mb-16 items-start">
          {/* 左：写真 */}
          <div className="lg:col-span-2">
            <div className="w-full h-[240px] md:h-[380px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fa23ef8feb383b0039c521da92fdc9fb.jpg"
                alt="受け入れ企業サポート"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* 右：サービス一覧 */}
          <div className="lg:col-span-3 space-y-3 md:space-y-4">
            <p className="text-slate-600 text-sm leading-relaxed mb-4 md:mb-6">
              特定技能外国人の受け入れには、複雑な申請手続きが伴います。
              当事務所では、書類作成から入管申請まで一貫してサポートし、
              企業様の負担を最小限に抑えます。
            </p>
            {services.map((service, index) => (
              <div
                key={index}
                className="flex items-start gap-3 md:gap-4 p-4 md:p-5 border border-slate-200 hover:border-blue-400 transition-colors duration-300 group"
              >
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-slate-100 group-hover:bg-[#1a3a5c] transition-colors duration-300 flex-shrink-0">
                  <i className={`${service.icon} text-slate-600 group-hover:text-blue-300 text-base md:text-lg transition-colors duration-300`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-slate-800 mb-1 text-sm"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    {service.title}
                  </h3>
                  <p className="text-slate-500 text-xs leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* お悩みセクション */}
        <div className="bg-slate-50 border-l-4 border-[#1a3a5c] px-5 md:px-8 py-6 md:py-8 mb-8 md:mb-10">
          <h3 className="text-base md:text-lg font-bold text-slate-800 mb-4 md:mb-6"
            style={{ fontFamily: "'Noto Serif JP', serif" }}>
            こんなお悩みはありませんか？
          </h3>
          <div className="grid sm:grid-cols-2 gap-3 md:gap-4 mb-5 md:mb-6">
            {concerns.map((concern, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center bg-[#1a3a5c] flex-shrink-0">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
                <p className="text-slate-700 text-sm">{concern}</p>
              </div>
            ))}
          </div>
          <div className="border-t border-slate-200 pt-4 md:pt-5">
            <p className="text-slate-800 font-bold text-sm md:text-base" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              そのお悩み、当事務所が解決いたします。
            </p>
            <p className="text-slate-500 text-sm mt-1">
              豊富な経験と実績で、確実な申請サポートを提供します。
            </p>
          </div>
        </div>

        {/* 受入れ企業様向けリンクバナー */}
        <a
          href="https://mkhoumujimu-visa.readdy.co/"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full bg-[#1a3a5c] hover:bg-[#0f2d52] transition-colors duration-300 cursor-pointer group"
        >
          <div className="flex flex-col md:flex-row items-center justify-between px-6 md:px-10 py-8 md:py-10 gap-5 md:gap-6">
            <div className="text-center md:text-left">
              <p className="text-blue-300 text-xs tracking-[0.3em] uppercase mb-2">For Accepting Companies</p>
              <p className="text-white/70 text-sm md:text-base mb-2">受入れ企業様はこちらへ</p>
              <p
                className="text-white text-2xl md:text-4xl lg:text-5xl font-bold group-hover:text-blue-200 transition-colors duration-300"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                行政書士ＭＫ法務事務所
              </p>
            </div>
            <div className="flex items-center gap-3 border border-white/30 group-hover:border-blue-300 px-6 md:px-8 py-3 md:py-4 transition-colors duration-300 flex-shrink-0">
              <span className="text-white text-sm font-medium tracking-widest whitespace-nowrap">サイトへ移動</span>
              <i className="ri-external-link-line text-blue-300 text-xl"></i>
            </div>
          </div>
        </a>

      </div>
    </section>
  );
};

export default CompanySection;
